import { render, staticRenderFns } from "./AddingPackageProfilePopup.vue?vue&type=template&id=efb5fe38"
import script from "./AddingPackageProfilePopup.vue?vue&type=script&lang=js"
export * from "./AddingPackageProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./AddingPackageProfilePopup.vue?vue&type=style&index=0&id=efb5fe38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports